<template>
  <svg :style="style" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_bingrenruyuan">
      <rect width="24" height="24" rx="4" fill="white" />
      <path id="Vector"
        d="M14.6445 11.9995C14.6445 11.8041 14.7222 11.6167 14.8603 11.4785C14.9985 11.3403 15.186 11.2627 15.3814 11.2627H18.6972C18.8926 11.2627 19.08 11.3403 19.2182 11.4785C19.3564 11.6167 19.434 11.8041 19.434 11.9995V18.2627C19.434 18.4581 19.3564 18.6455 19.2182 18.7837C19.08 18.9219 18.8926 18.9995 18.6972 18.9995H15.3814C15.186 18.9995 14.9985 18.9219 14.8603 18.7837C14.7222 18.6455 14.6445 18.4581 14.6445 18.2627V11.9995ZM16.1182 12.7364V17.5259H17.9603V12.7364H16.1182Z"
        fill="#FE553E" />
      <path id="Vector_2" d="M5.80273 5.7373H15.3817V18.2636H5.80273V5.7373Z" fill="#376EFF" />
      <path id="Vector_3"
        d="M5.06641 5.73684C5.06641 5.54142 5.14404 5.354 5.28222 5.21582C5.42041 5.07763 5.60783 5 5.80325 5H15.3822C15.5776 5 15.765 5.07763 15.9032 5.21582C16.0414 5.354 16.119 5.54142 16.119 5.73684V18.2632C16.119 18.4586 16.0414 18.646 15.9032 18.7842C15.765 18.9224 15.5776 19 15.3822 19H5.80325C5.60783 19 5.42041 18.9224 5.28222 18.7842C5.14404 18.646 5.06641 18.4586 5.06641 18.2632V5.73684ZM6.54009 6.47368V17.5263H14.6454V6.47368H6.54009Z"
        fill="#376EFF" />
      <path id="Vector_4" d="M8.01367 11.2627H13.1716V12.7364H8.01367V11.2627Z" fill="white" />
      <path id="Vector_5" d="M11.3292 9.4209V14.5788H9.85547V9.4209H11.3292Z" fill="white" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'in-hospital',
  props: {
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        'font-size': this.fontSize
      }
    }
  }
}
</script>